<template>
    <div style="width:100%;heigh:100%;" class="file-msg">
        <el-row :gutter="20">
            <el-col :span="3" style="padding-right:0px;">
                <el-card class="left-card">
                    <div class="left-title">
                        功能列表
                    </div>
                    <div class="middle-title">
                        附件类型
                        <el-tooltip class="item" effect="dark" placement="right">
                            <div slot="content">
                                不同类型的附件在相应的模块中使用<br/>
                                生产类：物料模块、工艺BOM、生产任务<br/>
                                质检类：质检模块<br/>
                                设备类：保养、点检、维修模块<br/>
                                其他附件：只用于文件存储
                            </div>
                            <i class="el-icon-question"></i>
                        </el-tooltip>
                    </div>
                    <div>
                        <el-tabs v-model="activeName" @tab-click="handleClick" tab-position="left">
                            <el-tab-pane v-for="(item,index) in FileTypeOption" :key="index" :label="item.name" :name="item.key"></el-tab-pane>
                        </el-tabs>
                    </div>
                </el-card>
            </el-col>
            <el-col :span="21" style="padding-left:0px;">
                <el-card class="table_searchbar">
                    <el-row :gutter="20">
                        <el-col :span="5">
                            <div class="" @keydown.enter="btnSearch()">
                            <span class="title">文件名：</span>
                            <el-input style="max-width:180px" size="small"  v-model="searchForm.fileName" maxlength="100" placeholder="文件名"></el-input>
                            </div>
                        </el-col>
                        <el-col :span="19">
                            <div style="text-align:right">
                                <el-button size='mini' icon="el-icon-search" type="primary" @click="btnSearch()">查询</el-button>
                                <el-button size='mini' icon="el-icon-refresh"  @click='clearSearch'>重置</el-button>
                            </div>
                        </el-col>
                    </el-row>
                </el-card>

                <el-card class="table-card">
                    <div class="table_common_operbar" v-if="permission.btn_file_upload">
                        <el-row>
                            <el-upload :action="uploadUrl()" :before-upload='beforeUpload' :on-success="uploadComplete" :show-file-list='false'>
                                <el-button  type="primary" size="small"   >上传附件</el-button>
                            </el-upload>
                        </el-row>
                    </div>

                    <el-table :data="tableData" stripe style="width: 100%" class="deviceTable">
                        <el-table-column prop="fileName" label="文件名称" min-width="200" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <div class="file-warp" >
                                    <div class="file-img"  :style="{backgroundImage:`url(${getFilePath(scope.row.fileName)})`, backgroundSize: '100%'}"></div>
                                    <span class="file-name">{{scope.row.fileName}}</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="gmtModified" label="上传时间" :formatter="parseTime" min-width="110" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="userName" label="操作人" min-width="80" show-overflow-tooltip></el-table-column>
                        <el-table-column label="操作" fixed="right" width="150">
                            <template slot-scope="scope">
                                <el-button @click="downFile(scope.row)" type="text" size="small" v-if="permission.btn_fileSys_download">下载</el-button>
                                <el-button @click="viewFile(scope.row)" type="text" size="small" v-if='canView(scope.row.url)&&permission.btn_file_get'>预览</el-button>
                                <el-button class="btn-del" @click="deleteFile(scope.row)" type="text" size="small" v-if="permission.btn_fileSys_delete">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>

                    <div class="page" v-if="tableData.length > 0">
                        <div class="total_page"><span> 共{{tableTotalPage}}条 10条/页</span></div>
                        <div style="margin-top:10px;text-align:right; margin-bottom:20px;" >
                            <el-pagination background layout="prev, pager, next" :total="tableTotalPage" @current-change="pageChange" :current-page="tableCurrentPage">
                            </el-pagination>
                        </div>
                    </div>
                </el-card>
            </el-col>
        </el-row>
        
        
    </div>
</template>

<script>
export default {
    name: 'fileMgt',
	data () {
        return {
            fristLoad:false,
            btnPressType: 0,//按钮类型： 0-默认 1-查询 2-重置 3-分页
            searchFormTemp: '',//临时搜索数据
            searchForm:{
                fileName:''
            },
            tableData:[],
            tableCurrentPage:1,
            tableTotalPage:100,
            addDialogVisible:false,
            viewDialogVisible:false,
            data: {
				token: localStorage.getItem("token"),
            },
            permission:JSON.parse(localStorage.getItem("permission")),
            FileTypeOption:[],
            activeName:null
        }
    },   
    mounted:function(){
        this.getDict("FileType").then(()=>{
            this.activeName = this.FileTypeOption.length>0?this.FileTypeOption[0].key:null;
            this.initTable();
        })
        
        let w  = document.documentElement.clientWidth || document.body.clientWidth;
         w>=1900?this.W = true:this.W = false
        window.onresize=()=>{
            let w  = document.documentElement.clientWidth || document.body.clientWidth;
            w>=1900?this.W = true:this.W = false
        }
        
    },
    deactivated:function(){
        console.log("deactivated");
    },
    computed:{
        span(){
           return this.W?5:7
        }
    },
    methods:{
        getDict(dict){
            return this.$RequestUtil.get({
                url: "/api/pull/list/list-dic",
                type: "sync",
                params: {
                bizCode: dict
                },
                success: res => {
                this[dict + "Option"] = res.data;
                }
            });
        },
        handleClick() {
            this.search();
        },
        parseTime(row){
            if(row.gmtModified){
                return commonUtils.timestampToDate(row.gmtModified)
            }
        },
        async downFile(row){
            let res = await this.$RequestUtil.getAsync({url:'/api/fileSys/downloadFile', type:'sync',dataType:'blob',params: {id:row.id},})
            // {type: 'application/application/vnd.ms-excel;charset=utf-8'}
            let blod =  new Blob([res])
            var downloadElement = document.createElement('a');
            var href = window.URL.createObjectURL(blod); //创建下载的链接
            downloadElement.href = href;
            downloadElement.download = row.fileName; //下载后文件名
            document.body.appendChild(downloadElement);
            downloadElement.click(); //点击下载
            document.body.removeChild(downloadElement); //下载完成移除元素
            window.URL.revokeObjectURL(href); //释放掉blob对象 
           
        },
        viewFile(row){
            window.open(row.url,'_blank');
            //let win = window.open("about:blank");
            //win.document.write('<img src='+row.url+'>')

        },
        btnSearch:function(){
            this.tableCurrentPage = 1;
            this.btnPressType = 1
            console.log(this.activeName);
            this.search();
        },
        clearSearch(){
            let form = this.searchForm;
            this.btnPressType = 2;
            form.fileName='';
        },
        search:function(){
            let temp;
            switch (this.btnPressType) {
              case 1:
                temp = commonUtils.cloneObj(this.searchForm);
                this.searchFormTemp = commonUtils.cloneObj(temp);
                break;
              case 0:
                temp ={
                  fileName: ''
                };
                break;
              case 2:
                temp = this.searchFormTemp;
                break;
              case 3:
                temp = this.searchFormTemp;
                break;
            }
            this.$RequestUtil.get({
                url: '/api/fileSys/getFileList',
                type:'sync',
				params: {
                    type:this.activeName,
                    pageNum:this.tableCurrentPage,
                    pageSize:10,
                    fileName:temp.fileName,
                },
                success: (res) => {
                    if(res.msg == this.$Global.RESPONSE.SUCCESS){
                        this.tableData = res.data;
                        this.tableTotalPage = res.totalPages;
                        if(res.totalPages == 0&&this.fristLoad){
                            this.$message.warning('查询不到符合条件的数据');
                        }
                        this.fristLoad = true
                    }else{
                        this.$message.error(res.msg||res.message);
                        
                    }
                }
            });
        },
        pageChange:function(targetPage){
            this.tableCurrentPage = targetPage;
            this.btnPressType = 3;
            this.search();
        },
        initTable:function(){
            this.search();
        },
        addWindowShow:function(){
            
        },
        deleteFile:function(rowData) {
            let message = '此操作将删除改文件，删除后不可撤回，是否继续';
            this.$confirm(message, '提示', {
                cancelButtonClass: "btn-custom-cancel",
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$RequestUtil.post({
                    url: '/api/fileSys/deleteFile',
                    type:'sync',
                    params: {
                        id:rowData.id
                    },
                    success: (res) => {
                        if(res.code != -1){
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                            this.initTable();
                            // this.$store.commit("add_reloadPages",['/WorkShop','/MasterData/UserMgt']);
                        }else {
                            this.$message({
                                type: 'error',
                                message: res.msg||res.message
                            });
                        }
                    }
                });
            });
        },

        uploadUrl:function(fileType,scope){
            let res = "/api/file/upload?token="+localStorage.getItem("token")+"&fileType="+this.activeName;
            return res
        },

        beforeUpload(file){
            if(!this.permission.btn_file_upload){
                this.$message({
                    type:'error',
                    message:`抱歉，您暂无文件上传权限`
                })
                return false
             }
            let fileSize = file.size/1024/1024
             fileSize = Math.round(fileSize*100)/100
            if(fileSize>=10){
                this.$message({
                    type:'error',
                    message:`文件大小不能超过5M,当前上传${file.name}大小为${fileSize}M`
                })
                 return false
            }
        },

        uploadComplete:function(response, file, fileList) {
            if(response.code==0){
                this.$message({
                    type:'success',
                    message:'上传成功'
                })
                this.initTable()
            }else{
                this.$message.error(response.msg||response.message)
            }
            
        },

        //传入文件名，返回文件对应路径
        getFilePath(fileName){
            if(!fileName){
                return
            }
            let filePath = ''
            let arr = fileName.split('.')
            let suffix = arr[arr.length-1]

            switch(true){
                case suffix == 'pdf'||suffix=='pptx':
                    filePath = '../../../static/img/pdf.png'
                    break
                case suffix == 'png'|| suffix == 'jpg' || suffix == 'svg':
                   filePath = '../../../static/img/pic.png'
                   break
                case suffix == 'txt'||suffix=='doc'||suffix=='docx':
                    filePath = '../../../static/img/txt.png'
                    break

                default:
                  filePath = '../../../static/img/file.png'
            }
            return filePath
        },

        //检测当前文件是否可以打开预览
        canView(url){
            if(!url){
                return false
            }
            let index = url.lastIndexOf(".");
            let ext = url.substr(index+1).toLowerCase();
            //可直接被浏览器打开的文件类型
            let arr = ['pdf','png','jpg','svg','txt','html','js','art','au','aiff','xbf','jpeg']
            if(arr.includes(ext)){
                return true
                // window.open(url,'_blank');
            }else{
                return false
                // window.location.href = url;
            }
        },
        
    }
}
</script>

<style>
  .file-msg .el-scrollbar__wrap{
        overflow-x: hidden;
        max-height:500px;
        height: auto;
        overflow-x: hidden;
        margin-bottom: 0px !important;
    }
  .import_upload>.el-upload-list{
      display: none;
   }
    .file-msg .el-date-editor.el-input, .file-msg .el-date-editor.el-input__inner{
      width:356px
    }
  /* .deviceTable .cell{
    padding-right:0px;
     overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap
} */
.table_searchbar .el-button--mini, .el-button--mini.is-round {
    padding: 7px 10px;
}
.file-msg .el-timeline-item__node--large{
     
    left: -6px;
    width: 22px;
    height: 22px;

}
 .select_width{
	width: 180px;
}
.file-msg .el-menu-item.is-active{
    color: #303133;
}
</style>
<style scoped>
.close-i{
	width: 14px;
	height: 14px;
	float: right;
    margin-top: 16px;
	background-image: url('../../../static/img/close.png');
}
.close-i:hover{
	background-image: url('../../../static/img/close-hover.png');
}
.delete{
    width: 18px;
    height: 19px;
    background-image:url('../../../static/img/del.png');
    cursor: pointer;
    background-repeat: no-repeat;
    position: relative;
    top: 9px;
}
.delete:hover{

    background-image: url('../../../static/img/del-hover.png');
    background-repeat: no-repeat;
}
.table_searchbar .title11{
    color:  #606266;
    font-family: NotoSansHans-Regula;
    font-size: 14px;
}
.el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
}

.import_upload{
	display: inline;
}
.page{
    display: flex;
    justify-content: flex-end;
}

.total_page{
    margin-top: 20px;
    margin-right: 26px;
    color:#606266;
    font-size: 14px;
}

.file-warp{
    height: 33px;
}
.file-img{
    width:26px;
    height: 33px;
    margin-right: 4px;
    display: inline-block;

}
.file-name{
    top: -10px;
    position: relative;
}
@media screen and (max-width: 1380px){
    .page{
        display: flex;
        justify-content: flex-end;
        margin-bottom:30px;
    }
}
.key{
    font-size: 16px;
    color:#c0c4cc;
    font-family: NotoSansHans-Regula;
    padding-right:10px;
    line-height:3
}
.addForm .value{
    display: inline-block;
    max-width: 180px;
}
.addForm .title{
    width: 70px;
    text-align: right;
    display:inline-block
}
.value{
    font-size:16px;
    color:#999;
    font-family: NotoSansHans-Regula;
    
    line-height: 3;
}
.view-form {
    width:90%;
    margin-left:10%
}
.qrcode_div{
    text-align:center;
}

.left-card .el-card__body{
    padding-left: 0px;
    padding-right: 0px;
}
.left-card .left-title{
    height: 35px;
    padding-left: 20px;
    font-weight: bold;
}
.left-card .middle-title{
    height: 35px;
    line-height: 35px;
    text-align: center;
    background: #F5F7FA;
}
</style>





// WEBPACK FOOTER //
// src/views/masterdata/FileMgt.vue